import { Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';

import FormFields from 'pages/components/FormFields';
import Section from 'pages/components/Section';

export default function ProfessionalInfos(props: any) {
  const { values, handleInputChange, options, formatErrorObject, errors } =
    props;

  const { t } = useTranslation();

  return (
    <Section title={'professional_infos'}>
      <FormFields.Select
        name="profession"
        value={values.profession}
        onChange={handleInputChange}
        options={options.profession}
        disabled
        required
        {...formatErrorObject(errors.profession)}
      />
      <FormFields.Select
        name="specialty"
        value={values.specialty}
        onChange={handleInputChange}
        options={options.specialty}
        disabled
        {...formatErrorObject(errors.language)}
      />
      <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
        <FormFields.TextInput
          name="iban"
          value={values.iban}
          onChange={handleInputChange}
          // required
          {...formatErrorObject(errors.iban)}
        />
        <Tooltip
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: 'none',
                whiteSpace: 'pre-wrap',
                fontSize: '0.875rem',
              },
            },
          }}
          title={<pre>{t('FEATURE.explain_iban')}</pre>}
          placement="top"
          arrow={true}
        >
          <InfoIcon />
        </Tooltip>
      </div>
      <FormFields.TextInput
        label={values.country + '-professionalNumber'}
        placeholder={values.country + '-professionalNumber'}
        name="professionalNumber"
        value={values.professionalNumber}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.professionalNumber)}
      />
      <FormFields.TextInput
        name="companyNumber"
        label={values.country + '-companyNumber'}
        placeholder={values.country + '-companyNumber'}
        value={values.companyNumber}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.companyNumber)}
      />
      <FormFields.TextInput
        name="companyName"
        value={values.companyName}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.companyName)}
      />
    </Section>
  );
}
